import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormHelperText from '@material-ui/core/FormHelperText';
import { employmentType } from '../../../../common/constants/Constants';
import { DateHelper } from '../../../../common/helper';
import { InputCheckItems, InputTextItems, JobDetailTemplate, JobImageTemplate, PageTitle, PaperWithTitle, PrimaryButton, ReactDateRange, } from '../../../components';
import { COLOR } from '../../../common/constants';
import { useMaster } from '../../../../model/hooks';
import { useJobOffer } from '../../../../model/hooks/job/JobOfferHooks';
import { useClinicUser } from '../../../../model/hooks/clinic/ClinicUserHooks';
import { FreeKeyword } from '../../../../model/firestore_model/common/entity';
import { InputFile } from '../../../components/organisms/InputFile';
import { SelectOccupation } from '../../../components/atoms/SelectOccupation';
import { Utils } from '../../../../common/helper';
import { useChangeEvent } from '../../../../model/hooks/common/ChangeEventHooks';
import wageAverageSrc from '../../../../common/images/wage_average.jpg';
import { hasPaymentBankTransfer, isPaymentCash } from '../../../common/helper';
export const JobOfferEditContents = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const history = useHistory();
    const location = useLocation();
    const { master } = useMaster();
    const { jobClinic } = useClinicUser();
    const { changeText, changeNumSelect, changeRadio } = useChangeEvent();
    const { loading, setRegisteredJobOfferId, registerJobOffer, updateRecruitment, loadJobOffer } = useJobOffer();
    const [title, setTitle] = useState('');
    const [occupation, setOccupation] = useState(0);
    const [checkMedicalDepartmentList, setCheckMedicalDepartmentList] = useState([]);
    const [description, setDescription] = useState('');
    const [rewardType, setRewardType] = useState('0');
    const [rewardAmount, setRewardAmount] = useState('1000');
    const [jobType, setJobType] = useState(`${employmentType.partTimeOneDay}`);
    const [checkNoSelectDate, setCheckNoSelectDate] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [startTime, setStartTime] = useState('00:00');
    const [endTime, setEndTime] = useState('00:00');
    const [checkPaymentList, setCheckPaymentList] = useState([]);
    const [paymentType, setPaymentType] = useState('yes');
    const [transportCost, setTransportCost] = useState('yes');
    const [recruitmentNumbers, setRecruitmentNumbers] = useState('1');
    const [remarks, setRemarks] = useState('');
    const [belongings, setBelongings] = useState(Array.from(Array(5), (_) => ''));
    const [submittedDocuments, setSubmittedDocuments] = useState(Array.from(Array(5), (_) => ''));
    const [applicationConditions, setApplicationConditions] = useState(Array.from(Array(5), (_) => ''));
    const [neededQualifications, setNeededQualifications] = useState(Array.from(Array(5), (_) => ''));
    const [checkRequirementList, setCheckRequirementList] = useState([]);
    const [templateThumbnail, setTemplateThumbnail] = useState(null);
    const [thumbnail, setThumbnail] = useState();
    const [thumbnailName, setThumbnailName] = useState(''); // isRegistered時のファイル名表示用
    const [documents, setDocuments] = useState(Array.from(Array(5), (_) => undefined));
    const [documentNames, setDocumentNames] = useState(Array.from(Array(5), (_) => '')); // isRegistered時のファイル名表示用
    const [isRegistered, setIsRegistered] = useState(false);
    const [isRecruitment, setIsRecruitment] = useState(true);
    const [jobOfferId, setJobOfferId] = useState('');
    const [isOpenJobDetailTemplate, setIsOpenJobDetailTemplate] = useState(false);
    const [isOpenJobImageTemplate, setIsOpenJobImageTemplate] = useState(false);
    const onChangeMedicalDepartment = useCallback((index, item, e) => {
        const list = checkMedicalDepartmentList.slice();
        list[index] = {
            id: item.id,
            text: item.text,
            value: e.target.checked,
        };
        setCheckMedicalDepartmentList(list);
    }, [checkMedicalDepartmentList]);
    const onChangeRequirement = useCallback((index, item, e) => {
        const list = checkRequirementList.slice();
        list[index] = {
            id: item.id,
            text: item.text,
            value: e.target.checked,
        };
        setCheckRequirementList(list);
    }, [checkRequirementList]);
    const onChangePaymentType = (e) => setPaymentType(e.target.value);
    const onChangeDateRange = (date) => {
        // 日付範囲選択の場合と単一日付選択の場合
        if ('selection' in date) {
            setStartDate(date.selection.startDate);
            setEndDate(date.selection.endDate);
        }
        else {
            setStartDate(date);
            setEndDate(date);
        }
    };
    const onChangeCheckNoSelectDate = (e) => setCheckNoSelectDate(e.target.checked);
    const onChangeStartTime = (e) => setStartTime(e.target.value);
    const onChangeEndTime = (e) => setEndTime(e.target.value);
    const onChangeBelongings = useCallback((index, value) => {
        const list = belongings.slice();
        list[index] = value;
        setBelongings(list);
    }, [belongings]);
    const onChangeSubmittedDocuments = useCallback((index, value) => {
        const list = submittedDocuments.slice();
        list[index] = value;
        setSubmittedDocuments(list);
    }, [submittedDocuments]);
    const onChangeApplicationConditions = useCallback((index, value) => {
        const list = applicationConditions.slice();
        list[index] = value;
        setApplicationConditions(list);
    }, [applicationConditions]);
    const onChangeNeededQualifications = useCallback((index, value) => {
        const list = neededQualifications.slice();
        list[index] = value;
        setNeededQualifications(list);
    }, [neededQualifications]);
    const onChangeThumbnail = (file) => {
        setThumbnail(file);
        setTemplateThumbnail(null);
    };
    const onChangeDocuments = useCallback((index, file) => {
        const list = documents.slice();
        list[index] = file;
        setDocuments(list);
    }, [documents]);
    const onClickOpenJobDetailTemplate = useCallback(() => setIsOpenJobDetailTemplate(true), []);
    const onCloseJobDetailTemplate = useCallback(() => setIsOpenJobDetailTemplate(false), []);
    const onClickSelectJobDetailTemplate = useCallback((text) => {
        setDescription(text);
        setIsOpenJobDetailTemplate(false);
    }, []);
    const onClickOpenJobImageTemplate = useCallback(() => setIsOpenJobImageTemplate(true), []);
    const onCloseJobImageTemplate = useCallback(() => setIsOpenJobImageTemplate(false), []);
    const onClickSelectJobImageTemplate = useCallback((file) => {
        setTemplateThumbnail(file);
        setIsOpenJobImageTemplate(false);
    }, []);
    const onClickNew = async () => {
        try {
            let startWorkingTime = null;
            let endWorkingTime = null;
            if (jobType === `${employmentType.partTimeOneDay}`) {
                startWorkingTime = DateHelper.toDateFromString(startTime, startDate, 'HH:mm').getTime();
                endWorkingTime = DateHelper.toDateFromString(endTime, endDate, 'HH:mm').getTime();
            }
            else if (jobType === `${employmentType.partTimeShort}`) {
                if (!checkNoSelectDate) {
                    startWorkingTime = startDate.getTime();
                    endWorkingTime = endDate.getTime();
                }
            }
            // 支払い方法の設定
            const allPaymentType = checkPaymentList.map((element) => element.id); // イモリー支払い「対応可能」の場合、現金も銀行振込も対応
            const cashOnlyPaymentType = checkPaymentList
                .filter((element) => isPaymentCash(element.id))
                .map((element) => element.id); // イモリー支払い「対応しない」の場合、現金のみ対応
            const paymentTypeIds = paymentType === 'yes' ? allPaymentType : cashOnlyPaymentType;
            // 単発パート以外は支払い方法をnullで登録
            const payments = jobType === `${employmentType.partTimeOneDay}` ? paymentTypeIds : null;
            const data = {
                jobOffer: {
                    title: title,
                    occupations: [occupation],
                    medicalDepartments: checkMedicalDepartmentList
                        .filter((element) => element.value === true)
                        .map((element) => element.id),
                    description: description,
                    rewardTypeId: parseInt(rewardType),
                    rewardAmount: parseInt(rewardAmount),
                    payments,
                    employmentId: parseInt(jobType),
                    isTransportationExpenses: transportCost === 'yes' ? true : false,
                    recruitmentNumbers: parseInt(recruitmentNumbers),
                    startWorkingTime: startWorkingTime,
                    endWorkingTime: endWorkingTime,
                    remarks: remarks,
                    belongings: belongings
                        .filter((element) => element.length > 0)
                        .map((element, index) => FreeKeyword.fromValue(index, element).toRequest()),
                    submittedDocuments: submittedDocuments
                        .filter((element) => element.length > 0)
                        .map((element, index) => FreeKeyword.fromValue(index, element).toRequest()),
                    applicationConditions: applicationConditions
                        .filter((element) => element.length > 0)
                        .map((element, index) => FreeKeyword.fromValue(index, element).toRequest()),
                    neededQualifications: neededQualifications
                        .filter((element) => element.length > 0)
                        .map((element, index) => FreeKeyword.fromValue(index, element).toRequest()),
                    jobRequirements: checkRequirementList
                        .filter((element) => element.value === true)
                        .map((element) => element.id),
                },
                thumbnails: thumbnail !== undefined ? [thumbnail] : undefined,
                thumbnailTemplate: templateThumbnail ? [templateThumbnail] : undefined,
                documents: documents.filter((element) => element !== undefined).map((element) => element),
            };
            await registerJobOffer(data);
            reactAlert.success(t('求人情報を登録しました'));
            history.push('/home/job_offer');
        }
        catch (e) {
            if (e instanceof Error) {
                reactAlert.error(e.message);
            }
        }
    };
    const onClickUpdateUpdateRecruitment = async (value) => {
        try {
            await updateRecruitment(jobOfferId, value);
            const message = value ? t('募集を開始しました') : t('募集を停止しました');
            reactAlert.success(message);
            setIsRecruitment(value);
        }
        catch (e) {
            if (e instanceof Error) {
                reactAlert.error(e.message);
            }
        }
    };
    // 求人内容取得(URL共有等stateが存在しない時に再取得)
    const loadJobOfferData = async () => {
        if (Utils.isNull(jobClinic) || Utils.isNull(location.search))
            return null;
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');
        const result = await loadJobOffer(jobClinic, (id !== null && id !== void 0 ? id : ''));
        return result.data[0];
    };
    // jobOffer設定
    const settingJobOffer = (jobOffer) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        // マスタ情報
        if (!master)
            return;
        const medicalDepartmentList = master.medicalDepartmentList.map((element) => {
            return { id: element.id, text: element.text, value: false };
        });
        const requirementList = master.requirementList.map((element) => {
            return { id: element.id, text: element.text, value: false };
        });
        const paymentList = master.paymentList.map((element) => {
            return { id: element.id, text: element.text, value: false };
        });
        // 詳細から遷移(参照のみ)の場合クエリパラメーターがあり、コピーして新規作成の場合はない
        if (location.search) {
            setIsRegistered(true);
            setRegisteredJobOfferId(jobOffer.jobOfferId);
            setJobOfferId(jobOffer.jobOfferId);
            setIsRecruitment(jobOffer.isRecruitment);
        }
        // 表示内容系
        setTitle(jobOffer.title);
        setOccupation(jobOffer.occupations[0]);
        const newMedicalDepartmentList = [...medicalDepartmentList];
        (_a = jobOffer.medicalDepartments) === null || _a === void 0 ? void 0 : _a.map((val) => {
            newMedicalDepartmentList[val].value = true;
        });
        setCheckMedicalDepartmentList(newMedicalDepartmentList);
        setDescription(jobOffer.description);
        setRewardType(`${jobOffer.rewardTypeId}`);
        setRewardAmount(`${jobOffer.rewardAmount}`);
        setJobType(`${jobOffer.employmentId}`);
        // 短期・パートで時間未設定の場合「期間を指定しない」にチェック
        setCheckNoSelectDate(jobOffer.employmentId === employmentType.partTimeShort && !jobOffer.startWorkingTime);
        if (jobOffer.startWorkingTime)
            setStartDate((_b = jobOffer.startWorkingTime) === null || _b === void 0 ? void 0 : _b.toDate());
        if (jobOffer.endWorkingTime)
            setEndDate((_c = jobOffer.endWorkingTime) === null || _c === void 0 ? void 0 : _c.toDate());
        if (jobOffer.startWorkingTime)
            setStartTime(DateHelper.toStringTimeOnly((_d = jobOffer.startWorkingTime) === null || _d === void 0 ? void 0 : _d.toDate()));
        if (jobOffer.endWorkingTime)
            setEndTime(DateHelper.toStringTimeOnly((_e = jobOffer.endWorkingTime) === null || _e === void 0 ? void 0 : _e.toDate()));
        setCheckPaymentList(paymentList);
        setPaymentType(hasPaymentBankTransfer((_f = jobOffer.payments, (_f !== null && _f !== void 0 ? _f : []))) ? 'yes' : 'no'); // 支払い方法に応じてラジオボタン設定
        setTransportCost(jobOffer.isTransportationExpenses ? 'yes' : 'no');
        setRecruitmentNumbers(`${jobOffer.recruitmentNumbers}`);
        setRemarks(jobOffer.remarks);
        const newBelongings = [...belongings];
        (_g = jobOffer.belongings) === null || _g === void 0 ? void 0 : _g.map((obj, idx) => {
            newBelongings[idx] = obj.text;
        });
        setBelongings(newBelongings);
        const newSubmittedDocuments = [...submittedDocuments];
        (_h = jobOffer.submittedDocuments) === null || _h === void 0 ? void 0 : _h.map((obj, idx) => {
            newSubmittedDocuments[idx] = obj.text;
        });
        setSubmittedDocuments(newSubmittedDocuments);
        const newApplicationConditions = [...applicationConditions];
        (_j = jobOffer.applicationConditions) === null || _j === void 0 ? void 0 : _j.map((obj, idx) => {
            newApplicationConditions[idx] = obj.text;
        });
        setApplicationConditions(newApplicationConditions);
        const newNeededQualifications = [...neededQualifications];
        (_k = jobOffer.neededQualifications) === null || _k === void 0 ? void 0 : _k.map((obj, idx) => {
            newNeededQualifications[idx] = obj.text;
        });
        setNeededQualifications(newNeededQualifications);
        const newRequirementList = [...requirementList];
        (_l = jobOffer.jobRequirements) === null || _l === void 0 ? void 0 : _l.map((val) => {
            newRequirementList[val].value = true;
        });
        setCheckRequirementList(newRequirementList);
        setThumbnailName(jobOffer.thumbnails ? (_m = jobOffer.thumbnails[0].metadata) === null || _m === void 0 ? void 0 : _m.filename : '');
        const newDocumentNames = [...documentNames];
        (_o = jobOffer.documents) === null || _o === void 0 ? void 0 : _o.map((obj, idx) => {
            var _a;
            newDocumentNames[idx] = (_a = obj.metadata) === null || _a === void 0 ? void 0 : _a.filename;
        });
        setDocumentNames(newDocumentNames);
    };
    useEffect(() => {
        if (master !== undefined) {
            const medicalDepartmentList = master.medicalDepartmentList.map((element) => {
                return { id: element.id, text: element.text, value: false };
            });
            setCheckMedicalDepartmentList(medicalDepartmentList);
            const requirementList = master.requirementList.map((element) => {
                return { id: element.id, text: element.text, value: false };
            });
            setCheckRequirementList(requirementList);
            const paymentList = master.paymentList.map((element) => {
                return { id: element.id, text: element.text, value: false };
            });
            setCheckPaymentList(paymentList);
            // 既存の求人の場合データを設定
            if (location.search) {
                // stateがなければ再取得、あればstateから設定
                if (location.state) {
                    settingJobOffer(location.state.jobOffer);
                }
                else {
                    const f = async () => {
                        const result = await loadJobOfferData();
                        if (!result)
                            return;
                        settingJobOffer(result);
                    };
                    f();
                }
                // コピーして新規作成の場合
            }
            else if (location.state) {
                settingJobOffer(location.state.jobOffer);
            }
        }
        // リロード時は最新の情報を取得したいためhistoryのstateを削除
        history.replace(`${history.location.pathname}${history.location.search}`);
    }, [master]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('求人新規作成')),
        React.createElement(SGrid, { container: true, justify: "center" },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaperWithTitle, { title: "\u52DF\u96C6\u5185\u5BB9" },
                    React.createElement(SGridForm, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12, md: 7 },
                            React.createElement(TextField, { required: true, label: t('業務内容'), placeholder: t('2時間程度麻酔科医としてオペに参加'), value: title, onChange: changeText(setTitle), fullWidth: true, disabled: isRegistered, error: !title })),
                        React.createElement(Grid, { item: true, xs: 12, md: 7 },
                            React.createElement(SelectOccupation, { value: occupation, menuItems: (_b = (_a = master) === null || _a === void 0 ? void 0 : _a.occupationList) === null || _b === void 0 ? void 0 : _b.map((d) => {
                                    return { value: d.id, text: d.text };
                                }), onChange: changeNumSelect(setOccupation), disabled: isRegistered })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormControl, { component: "fieldset", style: { marginTop: '16px' } },
                                React.createElement(FormLabel, { required: true, 
                                    // チェックボックスに１つもチェックが入っていないとき
                                    error: checkMedicalDepartmentList.every((checkItem, index, array) => {
                                        return !checkItem.value;
                                    }) }, t('診療科目')),
                                React.createElement(FormGroup, { row: true },
                                    React.createElement(InputCheckItems, { list: checkMedicalDepartmentList, name: "checkMedicalDepartmentList", disabled: isRegistered, onChange: onChangeMedicalDepartment })))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            !isRegistered && (React.createElement(STemplateButtonArea, null,
                                React.createElement(PrimaryButton, { size: "small", inverted: true, onClick: onClickOpenJobDetailTemplate }, t('テンプレートを使用')))),
                            React.createElement(TextField, { required: true, label: t('業務詳細'), placeholder: t('2時間程度麻酔科医としてオペに参加'), value: description, onChange: changeText(setDescription), disabled: isRegistered, fullWidth: true, multiline: true, error: !description })),
                        !isRegistered && (React.createElement(Grid, { item: true, xs: 12, md: 7, style: { marginTop: '16px' } },
                            React.createElement("img", { alt: t('時給の目安'), src: wageAverageSrc, style: { width: '100%' } }))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormControl, { component: "fieldset", style: { marginTop: '16px' } },
                                React.createElement(FormLabel, { required: true, error: !rewardType }, t('給与')),
                                React.createElement(RadioGroup, { name: "salary", row: true, value: rewardType, onChange: changeRadio(setRewardType) }, (_d = (_c = master) === null || _c === void 0 ? void 0 : _c.rewardTypeList) === null || _d === void 0 ? void 0 : _d.map((element, index) => (React.createElement(FormControlLabel, { key: index, value: `${element.id}`, control: React.createElement(Radio, { color: "primary" }), label: t(element.text), disabled: isRegistered })))))),
                        React.createElement(Grid, { item: true, xs: 6, md: 2 },
                            React.createElement(TextField, { required: true, type: "number", label: t('報酬額'), value: rewardAmount, onChange: changeText(setRewardAmount), disabled: isRegistered, fullWidth: true, error: !rewardAmount })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormControl, { component: "fieldset" },
                                React.createElement(FormLabel, { required: true, error: !jobType }, t('雇用形態')),
                                React.createElement(RadioGroup, { name: "jobType", row: true, value: jobType, onChange: changeRadio(setJobType) }, (_f = (_e = master) === null || _e === void 0 ? void 0 : _e.employmentList) === null || _f === void 0 ? void 0 : _f.map((element, index) => (React.createElement(FormControlLabel, { key: index, value: `${element.id}`, control: React.createElement(Radio, { color: "primary" }), label: t(element.text), disabled: isRegistered })))))),
                        jobType !== `${employmentType.fullTime}` && (React.createElement(Grid, { item: true, xs: 12, md: 4 },
                            React.createElement(FormLabel, { required: true, error: !employmentType }, t('就労期間')),
                            React.createElement("div", { style: { paddingTop: '8px' } },
                                jobType === `${employmentType.partTimeShort}` && (React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: checkNoSelectDate, onChange: onChangeCheckNoSelectDate, color: "primary" }), label: t('期間を指定しない'), disabled: isRegistered })),
                                React.createElement(ReactDateRange, { startDate: startDate, endDate: endDate, startTime: startTime, endTime: endTime, isHide: checkNoSelectDate, isSingle: jobType === `${employmentType.partTimeOneDay}`, onChangeDateRange: onChangeDateRange, onChangeStartTime: onChangeStartTime, onChangeEndTime: onChangeEndTime, disabled: isRegistered })))),
                        jobType === `${employmentType.partTimeOneDay}` && (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormControl, { component: "fieldset", style: { marginTop: '16px' }, disabled: isRegistered },
                                React.createElement(FormLabel, { required: true, error: !paymentType }, t('報酬のお支払いについて')),
                                React.createElement(SBoldText, null, t('イモリーでのお支払いに対応しますか？')),
                                React.createElement(SHelperText, null, t('対応可能にすると希望したワーカーに対しては、イモリーに登録したクレジットカードで 管理画面から報酬の支払いをすることができます。※決済手数料3.6%')),
                                React.createElement(RadioGroup, { name: "paymentType", row: true, value: paymentType, onChange: onChangePaymentType },
                                    React.createElement(FormControlLabel, { value: "yes", control: React.createElement(Radio, { color: "primary" }), label: t('対応可能') }),
                                    React.createElement(FormControlLabel, { value: "no", control: React.createElement(Radio, { color: "primary" }), label: t('対応しない') }))))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormControl, { component: "fieldset", style: { marginTop: '16px' }, disabled: isRegistered },
                                React.createElement(FormLabel, { required: true, error: !transportCost }, t('交通費')),
                                React.createElement(RadioGroup, { name: "transportCost", row: true, value: transportCost, onChange: changeRadio(setTransportCost) },
                                    React.createElement(FormControlLabel, { value: "yes", control: React.createElement(Radio, { color: "primary" }), label: t('あり') }),
                                    React.createElement(FormControlLabel, { value: "no", control: React.createElement(Radio, { color: "primary" }), label: t('なし') })))),
                        React.createElement(Grid, { item: true, xs: 6, md: 2 },
                            React.createElement(SRowBottom, null,
                                React.createElement(TextField, { required: true, label: t('募集人数'), type: "number", placeholder: "3", value: recruitmentNumbers, onChange: changeText(setRecruitmentNumbers), disabled: isRegistered, fullWidth: true, error: !recruitmentNumbers }),
                                React.createElement("span", { style: { marginLeft: '8px' } }, "\u4EBA"))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { required: true, label: t('注意事項'), placeholder: t('15分前に集合'), value: remarks, onChange: changeText(setRemarks), disabled: isRegistered, fullWidth: true, multiline: true, error: !remarks })),
                        React.createElement(Grid, { item: true, xs: 12, style: { marginTop: '16px' } },
                            React.createElement(SRow, null,
                                React.createElement(FormLabel, null, t('持ち物')),
                                React.createElement(SHelperText, null, t('勤務時に持ってきてもらうものがあればご記入ください。最大５種類まで設定可能。')))),
                        React.createElement(InputTextItems, { list: belongings, placeholder: ['身分証', '黒の靴下', '印鑑', 'メモ帳', '不織布の使い捨てマスク'], disabled: isRegistered, onChange: onChangeBelongings }),
                        React.createElement(Grid, { item: true, xs: 12, style: { marginTop: '16px' } },
                            React.createElement(SRow, null,
                                React.createElement(FormLabel, null, t('提出書類')),
                                React.createElement(SHelperText, null, t('応募時に提出必須な書類があればご記入ください。最大５種類まで設定可能。')))),
                        React.createElement(InputTextItems, { list: submittedDocuments, placeholder: ['履歴書', '職務経歴書', '保険薬剤師登録証'], disabled: isRegistered, onChange: onChangeSubmittedDocuments }),
                        React.createElement(Grid, { item: true, xs: 12, style: { marginTop: '16px' } },
                            React.createElement(SRow, null,
                                React.createElement(FormLabel, null, t('応募条件')),
                                React.createElement(SHelperText, null, t('最大５種類まで設定可能。')))),
                        React.createElement(InputTextItems, { list: applicationConditions, placeholder: ['調剤薬局での勤務経験', '年齢不問', '学生不問', '長期で勤務できる方歓迎'], disabled: isRegistered, onChange: onChangeApplicationConditions }),
                        React.createElement(Grid, { item: true, xs: 12, style: { marginTop: '16px' } },
                            React.createElement(SRow, null,
                                React.createElement(FormLabel, null, t('必要資格')),
                                React.createElement(SHelperText, null, t('最大５種類まで設定可能。')))),
                        React.createElement(InputTextItems, { list: neededQualifications, placeholder: ['薬剤師国家資格'], disabled: isRegistered, onChange: onChangeNeededQualifications }),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormControl, { component: "fieldset", style: { marginTop: '16px' } },
                                React.createElement(SRow, null,
                                    React.createElement(FormLabel, null, t('こだわり条件')),
                                    React.createElement(SHelperText, null, t('当てはまるものに☑チェックを入れてください。'))),
                                React.createElement(FormGroup, { row: true },
                                    React.createElement(InputCheckItems, { list: checkRequirementList, name: "checkRequirementList", disabled: isRegistered, onChange: onChangeRequirement })))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(FormLabel, { required: true, error: !templateThumbnail && !thumbnail }, t('写真をアップロード'))),
                        !isRegistered ? (React.createElement(React.Fragment, null,
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(PrimaryButton, { size: "small", inverted: true, onClick: onClickOpenJobImageTemplate }, t('テンプレートから選択する')),
                                templateThumbnail && (React.createElement("span", { style: { marginLeft: '16px' } }, (_j = (_h = (_g = templateThumbnail) === null || _g === void 0 ? void 0 : _g.metadata) === null || _h === void 0 ? void 0 : _h.filename, (_j !== null && _j !== void 0 ? _j : ''))))),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(InputFile, { onChange: onChangeThumbnail, disabled: isRegistered })))) : (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { value: thumbnailName, disabled: true, fullWidth: true }))),
                        React.createElement(Grid, { item: true, xs: 12, style: { marginTop: '16px' } },
                            React.createElement(SRow, null,
                                React.createElement(FormLabel, null, t('業務に関する書類')),
                                React.createElement(SHelperText, null, t('応募時にワーカーの方にご確認いただく書類を登録できます。最大５種類まで設定可能。')))),
                        !isRegistered ? (React.createElement(React.Fragment, null, documents.map((_, index) => {
                            return (React.createElement(Grid, { key: index, item: true, xs: 12 },
                                React.createElement(InputFile, { onChange: (file) => onChangeDocuments(index, file), disabled: isRegistered })));
                        }))) : (React.createElement(React.Fragment, null, documentNames.map((val, index) => {
                            return (React.createElement(Grid, { key: `${index}${val}`, item: true, xs: 12 },
                                React.createElement(TextField, { value: val, disabled: true, fullWidth: true })));
                        }))),
                        React.createElement(Grid, { item: true, xs: 12, style: { marginTop: '16px', textAlign: 'center' } }, isRegistered ? (React.createElement(React.Fragment, null, isRecruitment ? (React.createElement(PrimaryButton, { onClick: () => onClickUpdateUpdateRecruitment(false), loading: loading, width: "300px" }, t('募集をやめる'))) : (React.createElement(PrimaryButton, { onClick: () => onClickUpdateUpdateRecruitment(true), loading: loading, width: "300px" }, t('募集を始める'))))) : (React.createElement(PrimaryButton, { onClick: onClickNew, loading: loading, width: "300px" }, t('新規作成')))))))),
        React.createElement(JobDetailTemplate, { open: isOpenJobDetailTemplate, onClose: onCloseJobDetailTemplate, onClickSelect: onClickSelectJobDetailTemplate }),
        React.createElement(JobImageTemplate, { open: isOpenJobImageTemplate, onClose: onCloseJobImageTemplate, onClickSelect: onClickSelectJobImageTemplate })));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SGridForm = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
  @media (min-width: 600px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const STemplateButtonArea = styled.span `
  position: relative;
  left: 64px;
  top: 16px;
  z-index: 10;
`;
const SHelperText = styled(FormHelperText) `
  &&& {
    margin-left: 24px;
    color: ${COLOR.ORANGE700};
  }
`;
const SBoldText = styled.p `
  color: ${COLOR.GRAY_500};
  font-weight: 600;
  font-size: 0.9rem;
  margin-top: 4px;
  margin-bottom: 0;
`;
const SRow = styled.div `
  display: flex;
  align-items: center;
`;
const SRowBottom = styled.div `
  display: flex;
  align-items: flex-end;
`;
